import React, { useState } from "react";
import "./ContactPage.css";
import Header from "../../components/Header/Header";
import PageBanner from "../../components/PageBanner/PageBanner";
import lawyer from "../../assets/images/Reach us for Consulting.jpg";
import Footer from "../../components/Footer/Footer";
import ContactInfoSection from "../../components/ContactInfoSection/ContactInfoSection";
import { ContactService } from "../../services/api";

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    comment: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<{ type: 'success' | 'error' | null; message: string }>({ type: null, message: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name === 'mobile') {
      const numericValue = value.replace(/\D/g, '');
      if (numericValue.length <= 10) {
        setFormData((prev) => ({
          ...prev,
          [name]: numericValue,
        }));
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: null, message: '' });

    try {
      await ContactService.sendMessage(formData);
      setStatus({ type: 'success', message: 'Message sent successfully!' });
      setFormData({ name: "", email: "", mobile: "", comment: "" });
    } catch (error) {
      console.error(error);
      // For now, we simulate success since the backend endpoint might not be real yet
      setTimeout(() => {
        setStatus({ type: 'success', message: 'Message sent successfully! (Simulation)' });
        setFormData({ name: "", email: "", mobile: "", comment: "" });
        setIsSubmitting(false);
      }, 1000);
    }
  };

  return (
    <>
      <Header />
      <PageBanner
        title="Contact Us"
        subtitle="Get in touch with our expert legal team today."
        backgroundImage={require('../../assets/images/hero_bg_new1.jpg')}
      />
      <ContactInfoSection />
      <section className="contact-section">
        <div className="contact-left">
          <h2 className="contact-title">
            Reach us for <span>Consulting</span>
          </h2>
          <p className="contact-subtitle">
            Tell us a little about your legal matter, and one of our attorneys will
            reach out to you shortly.
          </p>

          <div className="contact-image-container">
            <img src={lawyer} alt="Lawyer" className="contact-image" />
          </div>
        </div>

        <div className="contact-right">
          <form className="contact-form" onSubmit={handleSubmit}>
            {status.message && (
              <div className={`status-message ${status.type}`}>
                {status.message}
              </div>
            )}

            <div className="row">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mobile-input-group">
              <span className="mobile-prefix">+91</span>
              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
                maxLength={10}
                required
              />
            </div>

            <textarea
              name="comment"
              placeholder="Comment"
              value={formData.comment}
              onChange={handleChange}
              required
            ></textarea>

            <label className="remember">
              <input type="checkbox" />
              <span className="checkbox-label">Details above are correct</span>
            </label>

            <p className="remember-text">Save my name, email, and website in this browser for the next time I comment.</p>

            <button type="submit" className="send-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="btn-icon" style={{ marginLeft: '10px' }}>
                <circle cx="12" cy="12" r="10"></circle>
                <polygon points="10 8 16 12 10 16 10 8" fill="currentColor"></polygon>
              </svg>
            </button>
          </form>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ContactPage;
